/**
 * Created by agengmaulana on 4/25/17.
 */
import React from 'react'
import ReactDOM from 'react-dom'
import Go from './index';
import PK from './prokontra';
import Datastore from './src/component/datastore/datastore'
const dataStore = new Datastore();

// import Raven from 'raven-js';
// import { sentry_url } from './config'
//
// Raven.config(sentry_url).install();

var comment = {

    cssinhead : function(url) {
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');

        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.media = 'all';
        head.appendChild(link);
    },
    jsinhead : function(url) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        head.appendChild(script);
    },
    create : function(config){
        dataStore.configKomentar = {
            'identifier': config.identifier,
            'target': 'root',
            'group': config.group,
            'date': config.date,
            'title': config.title,
            'appId': config.appId,
            'site': config.prefix,
            'link': config.url_dtk,
            'url_share': config.url_share,
            'prokontra': config.prokontra,
            'showhide': config.showhide,
            'label_1': config.label_1,
            'label_2': config.label_2,
            'onmasuk': config.onLogin,
            'onresize': config.onResize,
            'onalert': config.onAlert,
            'data_oa': config.data_oa,
            'onscroll': config.onScroll,
            'envAds': config.envAds,
            'kanalAds': config.kanalAds,
            'loadAsyncAds': config.loadAsyncAds,
            'currentUrl': config.currentUrl
        }

        var isMobile = {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };
        if(config.prokontra == 1) {
            comment.cssinhead(process.env.API_URL + 'static/src/assets/css/prokontra_comment.css?v=1.5.2')

        }
            comment.cssinhead(process.env.API_URL + 'static/src/assets/css/fonticon.css?v=1.3')
            comment.cssinhead('https://cdn.detik.net.id/libs/newcomment/css/slick.min.css?v=1.0')
            comment.cssinhead('https://cdn.detik.net.id/libs/newcomment/css/slick-theme.min.css?v=1.0')
            comment.cssinhead('https://cdn.detik.net.id/libs/newcomment/css/style.css?v=1.0')

        setTimeout(()=>{
            if (typeof(FB) != 'undefined' && FB != null ) {
            } else {
                // jika undefined panggil sharebox
                comment.jsinhead(process.env.API_URL+'static/src/assets/js/sharebox.js?=v1.5')

            }
        },2000)

        var loadcomment = <div className="plg_spinner"><img src="https://cdn.detik.net.id/libs/font-newcomment/gears.svg"/></div>;
        document.getElementById('root').innerHTML = loadcomment


        const objectnya = localStorage.getItem(dataStore.configKomentar.identifier)
        const json = JSON.parse(objectnya)
        let setlabel_awal
        if(objectnya != null){
            setlabel_awal = json.prokontraLabel
        }

        let artikel = 0

        if(objectnya != null){
            artikel = json.artikel
        }
        if(dataStore.configKomentar.identifier == artikel){
            dataStore.formStore = { 'content' : json.content, 'parentId' : json.parentId, 'prefix': json.prefix }
        }
        else {
            dataStore.formStore = ''
        }

        const url = config.url_dtk;
        const current_url = config.currentUrl
        const anchor = (url != current_url && current_url.indexOf("#cmt") != -1) ? dataStore.parsingURL(current_url) : dataStore.parsingURL(url)
        dataStore.anchor = anchor

        // render awal
        if(config.prokontra == 1){
            dataStore.fetchDataKomentarProkontra(1,'newest')
            ReactDOM.render(
                <PK label_1={config.label_1} setlabel_awal={setlabel_awal} label_2={config.label_2} dataStore={dataStore} isMobile={isMobile}/>,
                document.getElementById('root')

            )

        }else {
            dataStore.fetchData()
            dataStore.fetchDataKomentar(1,'newest')

            ReactDOM.render(
                <Go dataStore={dataStore} isMobile={isMobile}/>,
                document.getElementById('root')

            )
        }
    }
}

module.exports = comment;




// WEBPACK FOOTER //
// ./static/widget.js